import { render, staticRenderFns } from "./NewsList.vue?vue&type=template&id=49089fee&scoped=true&"
import script from "./NewsList.vue?vue&type=script&lang=js&"
export * from "./NewsList.vue?vue&type=script&lang=js&"
import style0 from "./NewsList.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./NewsList.vue?vue&type=style&index=1&id=49089fee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49089fee",
  null
  
)

export default component.exports